import(/* webpackMode: "eager" */ "/workspace/aregncapital/src/app/syndicate/page.tsx");
